"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTripRequest = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const CustomTripLocation_1 = require("./CustomTripLocation");
let CustomTripRequest = class CustomTripRequest {
    email;
    fullName;
    phoneNumber;
    origin;
    destination;
    /** Departure date in origin timezone (booking time, appears as UTC) */
    departureAt;
    passengersCount;
    childrenCount;
    stops;
    isLuxurySedanPreferred;
    isVanPreferred;
};
exports.CustomTripRequest = CustomTripRequest;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => value && value.trim().toLowerCase()),
    __metadata("design:type", String)
], CustomTripRequest.prototype, "email", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRequest.prototype, "fullName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRequest.prototype, "phoneNumber", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => CustomTripLocation_1.CustomTripLocation),
    (0, class_transformer_1.Type)(() => CustomTripLocation_1.CustomTripLocation),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", CustomTripLocation_1.CustomTripLocation)
], CustomTripRequest.prototype, "origin", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => CustomTripLocation_1.CustomTripLocation),
    (0, class_transformer_1.Type)(() => CustomTripLocation_1.CustomTripLocation),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", CustomTripLocation_1.CustomTripLocation)
], CustomTripRequest.prototype, "destination", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], CustomTripRequest.prototype, "departureAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CustomTripRequest.prototype, "passengersCount", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CustomTripRequest.prototype, "childrenCount", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [CustomTripLocation_1.CustomTripLocation], { nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], CustomTripRequest.prototype, "stops", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], CustomTripRequest.prototype, "isLuxurySedanPreferred", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], CustomTripRequest.prototype, "isVanPreferred", void 0);
exports.CustomTripRequest = CustomTripRequest = __decorate([
    (0, type_graphql_1.InputType)("CustomTripRequestInput"),
    (0, class_transformer_1.Exclude)()
], CustomTripRequest);
//# sourceMappingURL=CustomTripRequest.js.map